<template>
  <div class="wrapper">
    <div class="main-panel">
      <!-- begin:: App Modal Info -->
      <AppModalInfo
        ref="AppModalInfo"
        :show="infoModal.show"
        :title="infoModal.title"
        :messages="infoModal.messages"
        :buttons="infoModal.buttons"
      ></AppModalInfo>
      <!-- end:: App Modal Info -->

      <DashboardContent @click="toggleSidebar"> </DashboardContent>
      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import { mapGetters } from "vuex";
import TopNavbar from "./TopNavbar.vue";
import Sidebar from "@/views/components/SidebarPlugin/SideBar.vue";
import DashboardContent from "./Content.vue";
import AppModalInfo from "@/views/components/bases/modal/AppModalInfo.vue";
import AppLoading from "@/views/components/bases/loading/AppLoading.vue";
import { ROUTE_NAME, ERROR_CODE } from "@/core/constants";

export default {
  name: "Layout",
  components: {
    TopNavbar,
    Sidebar,
    // SidebarLink,
    // ContentFooter,
    DashboardContent,
    AppModalInfo,
    AppLoading,
  },
  data: () => ({
    infoModal: {
      show: false,
      title: "",
      messages: [],
      buttons: [],
      textbox: "",
      dropbox: [],
    },
  }),
  computed: {
    ...mapGetters(["subHeader", "layoutConfig"]),
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    openInfoModal(title, messages, buttons, code, textbox, dropbox) {
      this.infoModal = {
        title: title,
        messages: messages,
        buttons: buttons,
        textbox: textbox,
        dropbox: dropbox,
      };
      //Error Handle by error code
      if (
        [
          ERROR_CODE.UNAUTHORIZED,
          ERROR_CODE.MULTIPLE_LOGINS,
          ERROR_CODE.INVALID_TOKEN,
        ].includes(code)
      ) {
        let newButtons = [];
        this.infoModal.title = i18nHelper.getMessage(`errorTitle.${code}`);
        // ERROR_CODE Redirect Login page without popup message
        this.$router.push({ name: ROUTE_NAME.LOGIN });

        switch (code) {
          case ERROR_CODE.UNAUTHORIZED:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
          case ERROR_CODE.MULTIPLE_LOGINS:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
          case ERROR_CODE.INVALID_TOKEN:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
        }

        this.infoModal.buttons = newButtons;
      }

      this.infoModal.show = true;
    },
    closeInfoModal() {
      this.infoModal.show = false;
      this.infoModal.title = "";
      this.infoModal.messages = [];
      this.infoModal.buttons = [];
    },
  },
};
</script>
